(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_nf-location-hours-status"] && !Shopify.designMode) return;
  try {
    const CLOSED_TOKENS = ['gesloten', 'closed', 'geschlossen', 'fermé', 'ferme'];
  const APPOINTMENT_TOKENS = ['op afspraak', 'by appointment', 'nach vereinbarung', 'sur rendez-vous', 'sur rendezvous'];
  const OPENING_SOON_MINUTES = 90;

  const timeToMinutes = (time) => {
    const [hour, minute = 0] = String(time).split(':').map(Number);
    return hour * 60 + minute;
  };

  const amsterdamMinutes = () => {
    const parts = new Intl.DateTimeFormat('en-GB', {
      timeZone: 'Europe/Amsterdam',
      hour: '2-digit',
      minute: '2-digit',
      hour12: false,
    }).formatToParts(new Date());
    const hour = Number(parts.find((part) => part.type === 'hour')?.value);
    const minute = Number(parts.find((part) => part.type === 'minute')?.value);
    return hour * 60 + minute;
  };

  const statusFromHours = (value, minutesNow) => {
    const normalized = String(value ?? '').trim().toLowerCase();
    if (normalized === '' || CLOSED_TOKENS.includes(normalized)) {
      return { status: 'closed' };
    }
    if (APPOINTMENT_TOKENS.includes(normalized)) {
      return { status: 'appointment' };
    }

    const ranges = String(value)
      .split(/\s*,\s*|\s+en\s+/i)
      .map((range) => {
        const [start, end] = range.split(/\s*-\s*/).map((part) => part.trim());
        if (!start || !end) return null;
        return { start: timeToMinutes(start), end: timeToMinutes(end), endStr: end };
      })
      .filter(Boolean);

    for (const range of ranges) {
      if (minutesNow >= range.start && minutesNow <= range.end) {
        return { status: 'open', time: range.endStr };
      }
    }

    // "Binnenkort open" from 1.5 hours before a block starts.
    for (const range of ranges) {
      const minutesUntilOpen = range.start - minutesNow;
      if (minutesUntilOpen > 0 && minutesUntilOpen <= OPENING_SOON_MINUTES) {
        return { status: 'opening-soon' };
      }
    }

    return { status: 'closed' };
  };

  class NfHoursStatus extends HTMLElement {
    connectedCallback() {
      this.#apply(statusFromHours(this.dataset.hours, amsterdamMinutes()));
    }

    #apply(result) {
      const text = this.querySelector('.nf-hours-status__text');
      if (!text) return;

      this.classList.remove(
        'nf-hours-status--open',
        'nf-hours-status--closed',
        'nf-hours-status--appointment',
        'nf-hours-status--opening-soon'
      );
      this.classList.add(`nf-hours-status--${result.status}`);

      if (result.status === 'open') {
        const template = this.dataset.openTemplate || 'Open now until __TIME__';
        text.textContent = template.replace('__TIME__', result.time);
        return;
      }

      if (result.status === 'appointment') {
        text.textContent = this.dataset.appointmentLabel || '';
        return;
      }

      if (result.status === 'opening-soon') {
        text.textContent = this.dataset.openingSoonLabel || '';
        return;
      }

      text.textContent = this.dataset.closedLabel || '';
    }
  }

  if (!customElements.get('nf-hours-status')) {
    customElements.define('nf-hours-status', NfHoursStatus);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["nf-buy-buttons"] && !Shopify.designMode) return;
  try {
    class NfPdpSecondaryCta extends HTMLElement {
    connectedCallback() {
      this.closestSection = this.closest('.shopify-section, dialog');
      this.closestSection?.addEventListener('variant:update', this.onVariantUpdate);
    }

    disconnectedCallback() {
      this.closestSection?.removeEventListener('variant:update', this.onVariantUpdate);
    }

    onVariantUpdate = (event) => {
      if (event.detail.data.newProduct) {
        this.dataset.productId = event.detail.data.newProduct.id;
      } else if (event.detail.data.productId !== this.dataset.productId) {
        return;
      }

      this.hidden = event.detail.resource == null || event.detail.resource.available == false;
    };
  }

  if (!customElements.get('nf-pdp-secondary-cta')) {
    customElements.define('nf-pdp-secondary-cta', NfPdpSecondaryCta);
  }
  } catch(e) { console.error(e); }
})();

})();
